import axios from 'axios'
import API from '@/common/api'
import store from '..'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getFeatures ({ dispatch, state }) {
      const file = 'features/features.json'
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`).then(res => {
        return res.data.message
      }).catch((ex) => {
        return false
      })
    }
  },
  getters: {
    gotMessage: state => state.gotMessage,
    updateSetting: state => state.updateSetting
  }
}
